import { render, staticRenderFns } from "./TargetList.vue?vue&type=template&id=3bb9fb2b&scoped=true&"
import script from "./TargetList.vue?vue&type=script&lang=js&"
export * from "./TargetList.vue?vue&type=script&lang=js&"
import style0 from "./TargetList.vue?vue&type=style&index=0&id=3bb9fb2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb9fb2b",
  null
  
)

export default component.exports